import React, { useState, useCallback } from 'react';
import styled from 'styled-components';

// Right-click desktop context menu — classic XP style
// Options: Arrange Icons By, Refresh, Paste, New, Properties

function DesktopContextMenu({ onProperties, onScreensaver }) {
  const [menu, setMenu] = useState(null);

  const handleContextMenu = useCallback((e) => {
    // Only show on desktop background (not on icons, windows, or app content)
    if (e.target.closest('.icon') ||
      e.target.closest('.app__content') ||
      e.target.closest('.app__header') ||
      e.target.closest('.window') ||
      e.target.closest('footer') ||
      e.target.closest('.footer__start__menu')) {
      return;
    }
    e.preventDefault();
    setMenu({ x: e.clientX, y: e.clientY });
  }, []);

  const handleClose = useCallback(() => {
    setMenu(null);
  }, []);

  const handleClick = useCallback((action) => {
    switch (action) {
      case 'refresh':
        // Flash the screen briefly
        document.body.style.opacity = '0.95';
        setTimeout(() => { document.body.style.opacity = '1'; }, 100);
        break;
      case 'properties':
        if (onProperties) onProperties();
        break;
      case 'screensaver':
        if (onScreensaver) onScreensaver();
        break;
      default:
        break;
    }
    setMenu(null);
  }, [onProperties, onScreensaver]);

  React.useEffect(() => {
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('click', handleClose);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('click', handleClose);
    };
  }, [handleContextMenu, handleClose]);

  if (!menu) return null;

  return (
    <MenuContainer style={{ left: menu.x, top: menu.y }}>
      <SubMenuTrigger>
        <MenuItemText>Arrange Icons By</MenuItemText>
        <Arrow>▸</Arrow>
        <SubMenuDropdown>
          <MenuItem onClick={() => handleClick('arrange')}>
            <Check>✓</Check> Name
          </MenuItem>
          <MenuItem onClick={() => handleClick('arrange')}>Size</MenuItem>
          <MenuItem onClick={() => handleClick('arrange')}>Type</MenuItem>
          <MenuItem onClick={() => handleClick('arrange')}>Modified</MenuItem>
          <Separator />
          <MenuItem onClick={() => handleClick('arrange')}>
            <Check>✓</Check> Auto Arrange
          </MenuItem>
          <MenuItem onClick={() => handleClick('arrange')}>Align to Grid</MenuItem>
          <Separator />
          <MenuItem onClick={() => handleClick('arrange')}>Show Desktop Icons</MenuItem>
        </SubMenuDropdown>
      </SubMenuTrigger>
      <Separator />
      <MenuItem onClick={() => handleClick('refresh')}>Refresh</MenuItem>
      <MenuItem onClick={() => handleClick('screensaver')}>Screen Saver Preview</MenuItem>
      <Separator />
      <MenuItem disabled>Paste</MenuItem>
      <MenuItem disabled>Paste Shortcut</MenuItem>
      <MenuItem disabled>Undo Delete &nbsp;&nbsp;&nbsp; Ctrl+Z</MenuItem>
      <Separator />
      <SubMenuTrigger>
        <MenuItemText>New</MenuItemText>
        <Arrow>▸</Arrow>
        <SubMenuDropdown>
          <MenuItem onClick={() => handleClick('new')}>📁 Folder</MenuItem>
          <MenuItem onClick={() => handleClick('new')}>📝 Shortcut</MenuItem>
          <Separator />
          <MenuItem onClick={() => handleClick('new')}>📄 Text Document</MenuItem>
          <MenuItem onClick={() => handleClick('new')}>📊 Microsoft Excel Worksheet</MenuItem>
          <MenuItem onClick={() => handleClick('new')}>📝 Microsoft Word Document</MenuItem>
        </SubMenuDropdown>
      </SubMenuTrigger>
      <Separator />
      <MenuItem onClick={() => handleClick('properties')}>Properties</MenuItem>
    </MenuContainer>
  );
}

const MenuContainer = styled.div`
  position: fixed;
  z-index: 99998;
  background: #fff;
  border: 1px solid #808080;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  padding: 2px 0;
  min-width: 200px;
  font-family: Tahoma, 'Segoe UI', sans-serif;
  font-size: 11px;
`;

const MenuItem = styled.div`
  padding: 4px 24px 4px 28px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  color: ${({ disabled }) => (disabled ? '#808080' : '#000')};
  display: flex;
  align-items: center;
  white-space: nowrap;
  &:hover {
    background: ${({ disabled }) => (disabled ? 'transparent' : '#3169C6')};
    color: ${({ disabled }) => (disabled ? '#808080' : '#fff')};
  }
`;

const MenuItemText = styled.span`
  flex: 1;
`;

const Arrow = styled.span`
  margin-left: 16px;
  font-size: 9px;
`;

const Check = styled.span`
  position: absolute;
  left: 8px;
  font-size: 10px;
`;

const Separator = styled.div`
  height: 1px;
  background: #d0d0d0;
  margin: 2px 2px;
`;

const SubMenuTrigger = styled.div`
  position: relative;
  padding: 4px 24px 4px 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  white-space: nowrap;
  &:hover {
    background: #3169C6;
    color: #fff;
  }
  &:hover > div:last-child {
    display: block;
  }
`;

const SubMenuDropdown = styled.div`
  display: none;
  position: absolute;
  left: 100%;
  top: -2px;
  background: #fff;
  border: 1px solid #808080;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  padding: 2px 0;
  min-width: 180px;
  z-index: 1;
`;

export default DesktopContextMenu;
